let singleProductDetail = {
    pDetail: [],
    images: [],
    videos: [],
    categoryName: "",
    currGst: "",
    lowestPrice: undefined,
    pStatus: "",
    pPrice: "",
    pVend: {},
    vendToolHistArr: [],
    totalMediaCount: "",
    vendToolHistArrTRecords: "",
    offerprice: "",
    mainImg: "",
    mainVideo: "",
    msg: {
        text: undefined,
        type: ""
    },
    isLoading: false
}

const productDetailSingleReducer = (state = singleProductDetail, action) => {
    switch (action.type) {
        case "FETCH_PRO_DETAIL_SINGLE":
            return {
                ...state, isLoading: true, error: ""
            }
        case "FETCH_PRO_DETAIL_SINGLE_SUCCESS":
            let res = action.payload.data
            let gst;
            let lowPrice = undefined
            if (res.vendors && res.vendors[0] && res.vendors[0].taxClass && res.vendors[0].taxClass !== "" && res.vendors[0].taxClass !== undefined) {
                gst = res.vendors[0].taxClass
            }
            else {
                gst = res.taxClass
            }
            if (res.vendors[0].purchase_price > res.lowestPrice) {
                lowPrice = res.lowestPrice
            }
            let baseImg;
            let video;
            if (res.images && res.images.length > 0) {
                if (res.images[0].image.startsWith("products")) {
                    baseImg = res.images[0].image;
                }
                else if (res.images[0].image.startsWith("mob")) {
                    baseImg = res.images[0].image;
                }
                else {
                    let img = res.images[0].image.substr("41")
                    baseImg = img;
                }
            }
            if (res.videos && res.videos.length > 0) {
                if (res.videos[0].includes('products')) {
                    video = "https://media.toolsvilla.com/" + res.videos[0]
                }
                else{
                    video = "https://www.youtube.com/embed/" + res.videos[0]
                }
            }
            //SL-698
            let lowPriceMargin = undefined
            if (res.lowestPriceMargin) {
                lowPriceMargin = res.lowestPriceMargin
            }
            return {
                ...state,
                isLoading: false,
                images: res.images,
                mainImg: baseImg,
                mainVideo: video,
                videos: res.videos,
                categoryName: action.payload.category,
                pDetail: res,
                gstPercent: gst,
                currGst: gst,
                pPrice: res.vendors[0].purchase_price,
                lowestPrice: lowPrice,
                lowestPriceMargin: lowPriceMargin,
                //SL-975
                //pStatus: res.vendors[0].vActive,
                pStatus: res.vendors[0]?.stock > 0 ? 'ACTIVE' : 'INACTIVE',
                pVend: res.vendors[0],
                pkgs: res.pkgs,
                totalMediaCount: res.images.length + res.videos.length
            }
        case "FETCH_PRO_DETAIL_SINGLE_ERROR":
            return {
                ...state,
                isLoading: false,
                msg: {
                    ...state.msg, text: "Error", type: "error"
                }
            }


        case "FETCH_PRICE_HISTORY_SINGLE": {
            return {
                ...state
            }
        }
        case "FETCH_PRICE_HISTORY_SINGLE_SUCCESS": {
            let res = action.payload
            return {
                ...state,
                vendToolHistArr: res.data,
                offerprice: res.data[0].price,
                vendToolHistArrTRecords: res.totalRecords
            }
        }
        case "FETCH_PRICE_HISTORY_SINGLE_ERROR": {
            return {
                ...state
            }
        }

        case "FETCH_CATEGORY_SUCCESS": {
            let d = state.pDetail;
            let catList = action.payload.data.subCategories;
            let catname;
            d.categories.map((item, index) => {
                catList.map((pitem, pindex) => {
                    if (item === pitem._id) {
                        catname = pitem.categoryName
                    }
                })
            })
            return {
                ...state, categoryName: catname
            }
        }


        case "UPDATE_GST_PRODUCT_SINGLE":
            return {
                ...state
            }
        case "UPDATE_GST_PRODUCT_SINGLE_SUCCESS":
            return {
                ...state,
                currGst: action.payload.gst,
                msg: {
                    ...state.msg, text: "GST changed successfully", type: "success"
                }
            }
        case "UPDATE_GST_PRODUCT_SINGLE_ERROR":
            return {
                ...state,
                msg: {
                    ...state.msg, text: "Failed", type: "error"
                }
            }

        case "UPDATE_STATUS_PRODUCT_SINGLE":
            return {
                ...state
            }
        case "UPDATE_STATUS_PRODUCT_SINGLE_SUCCESS":
            let status;
            console.log(action.payload)
            if (action.payload.data.vActive === "INACTIVE") {
                status = "INACTIVE_REQ"
            }
            else {
                status = "ACTIVE"
            }
            return {
                ...state,
                pStatus: status,
                msg: {
                    ...state.msg, text: "Status updated", type: "success"
                }
            }
        case "UPDATE_STATUS_PRODUCT_SINGLE_ERROR": {
            return {
                ...state, msg: {
                    ...state.msg, text: "Failed", type: "error"
                }
            }
        }

        case "NEW_PRICEREQ_SINGLE": {
            return {
                ...state,
            }
        }
        case "NEW_PRICEREQ_SINGLE_SUCCESS": {
            return {
                ...state,
                pVend: {
                    ...state.pVend, prSts: "T_PENDING"
                },
                msg: {
                    ...state.msg, text: "Price request submitted", type: "success"
                }
            }
        }
        case "NEW_PRICEREQ_SINGLE_ERROR": {
            return {
                ...state, msg: {
                    ...state.msg, text: "Failed", type: "error"
                }
            }
        }

        case "VERIFY_PRICE_PRODUCT_SINGLE": {
            return {
                ...state,
            }
        }
        case "VERIFY_PRICE_PRODUCT_SINGLE_SUCCESS": {
            return {
                ...state,
                pVend: {
                    ...state.pVend, prSts: "V_ACTIVE"
                },
                msg: {
                    ...state.msg, text: "Verified", type: "success"
                }
            }
        }
        case "VERIFY_PRICE_PRODUCT_SINGLE_ERROR": {
            return {
                ...state, msg: {
                    ...state.msg, text: "Failed", type: "error"
                }
            }
        }

        case "UPDATE_OFFER_PRICEREQ_PRODUCT_SINGLE": {
            return {
                ...state,
            }
        }
        case "UPDATE_OFFER_PRICEREQ_PRODUCT_SINGLE_SUCCESS": {
            return {
                ...state,
                pPrice: action.payload.data,
                pVend: {
                    ...state.pVend, prSts: "V_ACTIVE"
                },
                msg: {
                    ...state.msg, text: "Verified", type: "success"
                }
            }
        }
        case "UPDATE_OFFER_PRICEREQ_PRODUCT_SINGLE_ERROR": {
            return {
                ...state, msg: {
                    ...state.msg, text: "Failed", type: "error"
                }
            }
        }

        default:
            return {
                ...state
            }
    }
}

export default productDetailSingleReducer;